import { SECOND } from 'constants/date'

export const AVATAR_SIZE = 32
export const AVATAR_BORDER_WIDTH = 4
export const MAX_AVATARS = 5
export const POPUP_OPEN_DELAY = SECOND * 0.3
export const POPUP_CLOSE_DELAY = SECOND * 1.5
